import Link from 'next/link'
import { Button } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import ApiKeyModal from './ApiKeyModal/ApiKeyModal'
import { getFormatedPrice } from 'src/core/helpers'
import { BarChartOutlined } from '@ant-design/icons'
import styles from './MyIntegrationResume.module.scss'
import { CustomCard, StaticsText } from 'src/components'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import { currencyListSelector, integrationStaticsSelector } from 'src/features'

const MyIntegrationResume: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { isMobile } = useWindowSize()

  const { data } = useAppSelector(integrationStaticsSelector)
  const link = `/developers/whitelabel-data/?initials=${data.integration_code}&id=${data.integration_id}`
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c?.symbol === data?.currency_symbol)?.code

  const isWhitelabel = data?.integration_type === 'WHITELABEL'

  const integrationType = {
    PREPURCHASE: t('developers.IntegrationTypeLabels.PREPURCHASE'),
    CREDIT: t('developers.IntegrationTypeLabels.CREDIT'),
    WHITELABEL: t('developers.IntegrationTypeLabels.WHITELABEL')
  }[data?.integration_type]

  const textsArray = [
    { label: t('developers.IntegrationCode'), text: data?.integration_code },
    { label: t('developers.IntegrationType'), text: integrationType },
    { label: t('developers.IntegrationID'), text: `#${data?.integration_id}` },
    { label: t('developers.TotalTransaction'), text: data?.total_transactions },
    { label: t('developers.TotalValue'), text: getFormatedPrice(data?.sum_amount, currencyCode) },
    { label: t('developers.TotalCO2Compensate'), text: `${data?.compensated_amount?.toFixed(2)} tCO₂` },
  ]

  return <div className={isMobile && 'mt-4'}>
    <CustomCard
      className={`${styles['resume-card']}`}
      cardTitle={t('developers.IntegrationResume')}
      loading={isLoading}
      extra={<Button
        className='radius-100'
        onClick={() => setIsModalVisible(true)}
      >{t('developers.ViewAPIKey')}
      </Button>}
    >
      {textsArray.map((item, idx) => <StaticsText
        label={item.label} text={item.text} key={idx}
      />)}
      {isWhitelabel && (
        <Link href={link} passHref>
          <Button
            size='middle'
            className={styles.whitelabelButton}
            icon={<BarChartOutlined />}
          >
            {t('developers.SeeWhitelabelFunnel')}
          </Button>
        </Link>
      )}
    </CustomCard>
    <ApiKeyModal
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
    />
  </div>
}

export default MyIntegrationResume
